import { useState, useEffect, useCallback, useRef } from 'react';
import { sendRequest } from './authFunctions';

const useFetch = (initialState) => {
  const isFetching = useRef(false);
  const [data, setData] = useState(initialState);

  // it will reset the back to initial state when url chnage.
  const getData = useCallback(
    (url) => {
      setData({ ...initialState, url });
      isFetching.current = true;
    },
    [initialState],
  );

  useEffect(() => {
    if (isFetching.current) {
      isFetching.current = false;
      const fetchData = async () => {
        try {
          setData({ ...data, isLoading: true });
          const result = await sendRequest(data.url);
          setData({ ...data, result, isLoading: false });
        } catch (err) {
          setData({ ...data, result: null, isLoading: false, error: err });
        }
      };
      fetchData();
    }
  }, [isFetching, data]);

  return { data, getData };
};
export default useFetch;
